import React, { useEffect, useState, useContext } from 'react';
import { Button, Row, Col, Divider, Space, Spin, Select, DatePicker, message, Table, Typography, Tag, Tooltip } from 'antd';
import AppContext from "../AppContext"
import moment from 'moment';
import { onGetAttendancelist } from '../../Controller/Attendance';
import { getAllUserLists, getUserbyId } from '../../Controller/Management/UserProf_Ctrl';
import { onGetShift } from '../../Controller/Management/ShiftManagement';
import { onGetHoliday, onGetHolidayByDate } from '../../Controller/Management/HolidaysManagement';
import { ReloadOutlined, VerticalAlignBottomOutlined } from "@ant-design/icons";
import T_Error from "../404";
import { ExportExcel } from '../../Controller/ExportToExcel';
import "../../css/attendance.css";
import {
    Table as TableMUI,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography as TypographyMUI,
    Collapse,
    IconButton,
    Box,
} from '@mui/material';

import { DateRange, KeyboardArrowDown, KeyboardArrowUp, Recommend } from '@mui/icons-material';
const { Option } = Select;
const { Text } = Typography;
const { RangePicker } = DatePicker;

export default function Attendance(prop) {
    //===== VARIABLE ====
    const global = useContext(AppContext)
    const userid = global.UserIdentity.userid;
    const [btndisable, setBtnDisable] = useState(false);
    const [isMaintenance, setIsMaintenance] = useState(false);      // Used for maintenance
    // ===== LIST ======
    const [datasource, setDatasource] = useState([]);
    const [shiftlist, setShiftList] = useState([])
    const [userLists, setUserLists] = useState([]);
    const [initLoading, setInitLoading] = useState(true);
    const [searchUser, setSearchUser] = useState("");
    //===== TOTAL USER =========
    const [totaluser, settotaluser] = useState(0);
    const [usertaken, setusertaken] = useState(0);
    const [userleft, setuserleft] = useState(0);
    //===== STATE ======
    const [date, setDate] = useState("");
    const [datesrange, setDatesRange] = useState([]);
    const [dateFilter, setDateFilter] = useState("date");
    const [holidaylist, setHolidaylist] = useState([])
    const [shiftFilter, setShiftFilter] = useState("flexible");
    const [leavetypefilter, setleavetypefilter] = useState(undefined);
    //======= LEAVE TYPES ========
    const leavetypes = ["Att", "MC", "EL", "AL", "WFH"];
    //====== DETAILS TABLE ========
    const [detailsTable, setDetailsTable] = useState({});


    useEffect(() => {
        return Promise.all([getAllUserLists({}), onGetShift({})])
            .then(([list, shiftlist]) => {

                setUserLists(list.data);
                setShiftList(shiftlist.data);
                settotaluser(list.data.length);
                setDate(moment());
            });
    }, []);

    useEffect(() => {
        setDate(moment())
    }, [dateFilter])

    useEffect(() => {
        //===== LEAVE TYPE FILTER ====
        let tempuserid = searchUser
        let tempshift = shiftFilter
        if (tempuserid.length > 0) {
            tempuserid = userLists.filter(x => x.userid == searchUser)[0]._id;

        }
        console.log("date >>>", date)
        console.log("datesrange >>>", datesrange)

        if (leavetypefilter == undefined) {
            onRefresh({ searchuser: tempuserid, shifttype: tempshift })
                .then(val => {
                    console.log("refresh val >>>", val)
                    if (val != undefined) {
                        setDatasource(val.data);
                    }

                });
        }
        else {
            onRefresh({ searchuser: tempuserid, shifttype: tempshift })
                .then(val => {
                    let newds = val.data.filter(x => x.type == leavetypefilter);
                    setDatasource(newds);
                })
        }
    }, [date, leavetypefilter, shiftFilter])

    useEffect(() => {
        let tempuserid = searchUser

        let tempshift = shiftFilter
        if (tempuserid.length > 0) {
            tempuserid = userLists.filter(x => x.userid == searchUser)[0]._id;

        }
        onMonthRefresh({ searchuser: tempuserid, shifttype: tempshift })
            .then(val => {
                if (val) {
                    setDatasource(val.data);
                }

            });
    }, [datesrange])

    useEffect(() => {
        let userleft = totaluser - usertaken;
        setuserleft(userleft);
    }, [totaluser, usertaken])

    const convertSecondsToTime = (seconds) => {
        if (seconds == 0 || seconds == undefined || seconds == null) {

            return ` - `;
        }
        else {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);

            if (hours > 0) {
                return `${hours}h ${minutes}m`;
            }

            return `${minutes}m`;
        }

    };

    // Function to format timestamp to time
    const formatTimestampToTime = (timestamp, dts) => {


        const momentObj = moment.unix(timestamp);
        const formattedTime = momentObj.format('HH:mm');

        // Check if the date is different from dts
        if (momentObj.format('YYYY-MM-DD') !== moment.unix(dts).format('YYYY-MM-DD')) {
            return `${momentObj.format('D/M')} ${formattedTime} AM`;
        }

        return formattedTime;


    };

    //===== FUNCTION =====
    const onRefresh = (data) => {
        let { searchuser = '', shifttype = '' } = data;

        // Filter records with worktype equal to 'shifttype'
        const FilterworktypeRecords = shiftlist.filter(record => record.worktype === shifttype);

        // Create a new array with only the _id values
        const filterworktypeIds = FilterworktypeRecords.map(record => record._id);

        //console.log("filterworktypeIds >>>", filterworktypeIds)

        let newDate = "";
        if (date != null && date != "") {
            switch (dateFilter) {
                case "month":
                    newDate = date.format("YYYY/MM");
                    break;
                default:
                    newDate = date.format("YYYY/MM/DD");
                    break;
            }
        }

        console.log("newDate >>>", newDate)
        //====== TO GET ATTENDANCE LIST ======
        return onGetAttendancelist({
            date: newDate,
            searchuser: searchuser,
            datetype: dateFilter
        })
            .then((val) => {
                let tempuserid = searchuser
                if (searchuser.length > 0) {
                    tempuserid = userLists.filter(x => x._id == searchuser)[0].userid;

                }

                val.data = onGetDatasource(val.data, tempuserid, newDate, newDate, filterworktypeIds, val.holidays);

                console.log("refresh val >>>", val)
                setInitLoading(false);
                return val;
            })
            .catch(err => {
                console.log("err11", err)
                //message.error("Cannot get data11");
                setIsMaintenance(true);
            });
    }

    const onExportToExcel = () => {
        //---- FILTER NEW DATASOURCE -----
        var newdatasource = [];
        if (dateFilter == "date") {
            datasource.forEach(data => {
                let obj = {};
                let punchin = data.punchin == "" ? "" : moment.unix(data.punchin).format("h:mm a");
                let punchout = data.punchout == "" ? "" : moment.unix(data.punchout).format("h:mm a");

                obj["username"] = data.username;
                obj["type"] = data.type;
                obj["punchin"] = punchin;
                obj["punchout"] = punchout;
                obj["branchin"] = data.branchin == "" || data.branchin == undefined ? data.bipin : data.branchin;
                obj["branchout"] = data.branchout == "" || data.branchout == undefined ? data.bipout : data.branchout;


                newdatasource.push(obj);
                ExportExcel(showFixedDatecolumns, newdatasource, `Att${moment(date).format("YYYYMMDD")}`);
            });
        }
        else {
            newdatasource = datasource;
            let filename = "";
            if (dateFilter == "monthrange") {
                filename = `AttFrm${moment(datesrange[0]).format("YYYYMM")}To${moment(datesrange[1]).format("YYYYMM")}`
            }
            else {
                filename = `Att${moment(date).format("YYYYMM")}`;
            }

            ExportExcel(showMonthcolumns, newdatasource, filename);
        }


        message.success("export successful")
    }

    //=== MONTH RANGE DATASOURCE ====
    const onMonthRefresh = (data) => {
        let { searchuser = '', shifttype = '' } = data;
        let startDate, endDate = "";

        // Filter records with worktype equal to 'shifttype'
        const FilterworktypeRecords = shiftlist.filter(record => record.worktype === shifttype);

        // Create a new array with only the _id values
        const filterworktypeIds = FilterworktypeRecords.map(record => record._id);

        if (dateFilter == 'monthrange') {
            if (datesrange != null && datesrange.length > 0) {
                startDate = datesrange[0].startOf("month").format("YYYY/MM/DD") || "";
                endDate = datesrange[1].endOf("month").format("YYYY/MM/DD") || "";
            }
        }
        else if (dateFilter == "week") {
            if (datesrange != undefined && datesrange != null) {
                startDate = datesrange.startOf("week").format("YYYY/MM/DD") || "";
                endDate = datesrange.endOf("week").format("YYYY/MM/DD") || "";

            }
        }
        else if (dateFilter == "weekrange") {
            if (datesrange != null && datesrange.length > 0) {
                startDate = datesrange[0].startOf("week").format("YYYY/MM/DD") || "";
                endDate = datesrange[1].endOf("week").format("YYYY/MM/DD") || "";
            }
        }
        else if (dateFilter == "month") {
            if (datesrange != null && datesrange != undefined) {
                startDate = datesrange.startOf("month").format("YYYY/MM/DD") || "";
                endDate = datesrange.endOf("month").format("YYYY/MM/DD") || "";
            }
        }


        console.log("dateFilter >>>", dateFilter)
        console.log("datesrange >>>", datesrange)
        console.log("startDate >>>", startDate)
        console.log("endDate >>>", endDate)
        return onGetAttendancelist({
            date: startDate,
            enddate: endDate,
            searchuser: searchuser,
            datetype: dateFilter
        })
            .then((val) => {
                console.log("range data1 >>>", val)

                console.log("range data2 >>>", val.data)
                let tempuserid = searchuser
                if (searchuser.length > 0) {
                    tempuserid = userLists.filter(x => x._id == searchuser)[0].userid;

                }


                setHolidaylist(val.hoiliday)
                val.data = onGetDatasource(val.data, tempuserid, startDate, endDate, filterworktypeIds, val.holidays);
                console.log("refresh month val >>>", val)
                setusertaken(val.data.length);
                setInitLoading(false);
                return val;
            })
            .catch(err => {
                console.log("err2", err)
                //message.error("Cannot get data22");
                setIsMaintenance(true);
            });

    }

    //20210727 add refresh all windows
    const onReload = () => {
        setBtnDisable(true);
        window.location.reload();
    }


    // EXPANDABLE
    const expandedDateRender = (record) => {
        //===== CALL DATASOURCE (DETAILS) =====
        if (shiftFilter == 'flexible') {
            return (
                <>
                    <TableMUI size="small" aria-label="purchases">
                        <TableHead>
                            <TableRow>
                                <TableCell>In</TableCell>
                                <TableCell>Out</TableCell>
                                <TableCell>Work</TableCell>
                                <TableCell>Extra</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                record ?
                                    record.details.map((detailItem, index) => (
                                        detailItem.sections == 'full' ?

                                            <TableRow key={index}>
                                                <TableCell><a>{detailItem.type}</a></TableCell>
                                                <TableCell><a>{"Full"}</a></TableCell>
                                            </TableRow>
                                            :
                                            detailItem.sections == 'half' ?
                                                <TableRow key={index}>
                                                    <TableCell><a>{detailItem.type}</a></TableCell>
                                                    <TableCell><a>{"Half"}</a></TableCell>
                                                </TableRow>
                                                :
                                                detailItem.type == 'Free' ?
                                                    <TableRow key={index}>
                                                        <TableCell><a>{"Free"}</a></TableCell>
                                                        <TableCell>{""}</TableCell>
                                                        <TableCell>{convertSecondsToTime(detailItem.workduration)}</TableCell>
                                                        <TableCell>{convertSecondsToTime(detailItem.extra)}</TableCell>
                                                    </TableRow>
                                                    :
                                                    (['AL', 'MC', 'EL', 'UL', "HL", 'Trip'].includes(detailItem.type)) ?
                                                        <TableRow key={index}>
                                                            <TableCell><a>{detailItem.type}</a></TableCell>
                                                            <TableCell><a>{"Full"}</a></TableCell>
                                                        </TableRow>
                                                        :
                                                        <TableRow key={index}>
                                                            <TableCell>{formatTimestampToTime(detailItem.punchin, detailItem.dts)} - {detailItem.branchin == '' ? 'Outside' : detailItem.branchin} </TableCell>
                                                            <TableCell>{detailItem.punchout != '' ? `${formatTimestampToTime(detailItem.punchout, detailItem.dts)} - ${detailItem.branchout == '' ? "Outside" : detailItem.branchout}` : ''}</TableCell>
                                                            <TableCell>{convertSecondsToTime(detailItem.workduration)}</TableCell>
                                                            <TableCell>{convertSecondsToTime(detailItem.extra)}</TableCell>
                                                        </TableRow>


                                    ))
                                    :
                                    ''
                            }


                        </TableBody>
                    </TableMUI>
                </>
            )
        }
        else {
            return (
                <>
                    <div>Remark : {record.remark}</div>
                    <div style={{ color: record.isenoughduration == 1 ? "green" : record.isnotenoughduration == 1 ? "red" : "" }}>
                        Enough Duration (Min)  : {record.isenoughduration == 1 ? Number(Number(record.enoughduration) / 60).toFixed(1) : Number((Number(record.notenoughduration) * -1) / 60).toFixed(1)}
                    </div>
                    <div style={{ color: record.isenoughduration == 1 ? "green" : record.isnotenoughduration == 1 ? "red" : "" }}>
                        Enough Duration (Hrs)   : {record.isenoughduration == 1 ? Number(Number(record.enoughduration) / 60 / 60).toFixed(1) : (Number(Number(record.notenoughduration) * -1) / 60 / 60).toFixed(1)}
                    </div>
                    {/* IF HAS OT */}
                    {/* {(() => {
                        return getUserbyId({ userid: record.username })
                        .then(res => {
                            if(res.status == "ok"){
                                return (
                                    <></>
                                )
                            }
                            else{
                                return (
                                    <></>
                                )
                            }
                        })
                    })()} */}
                </>
            )
        }

    }

    const Row1 = ({ data }) => {
        // Check if data.dts corresponds to the current day
        const isCurrentDay = moment.unix(data.dts).isSame(moment(), 'day');

        // Set the default value for 'open' based on whether it's the current day
        const [open, setOpen] = React.useState(isCurrentDay);

        let color;
        switch (data.type) {
            case "Att":
                color = "green";
                break;
            case "WFH":
                color = "blue";
                break;
            case "AL":
                color = "cyan";
                break;
            case "MC":
                color = "purple";
                break;
            case "EL":
                color = "orange";
                break;
            case "Free":
                color = "grey";
                break;
            case "Trip":
                color = "volcano";
                break;
            default:
                color = "";
                break;
        }

        let countrecord = 0
        let displaytext = ''

        if (data) {
            countrecord = data.details.length

            if (data.missingpunchout == 1) {
                countrecord = countrecord - 1
            }

            if (countrecord > 0) {
                displaytext = ` (${countrecord})`
            }
        }
        return (
            <>
                <TableRow>
                    <TableCell>
                        <IconButton size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                        </IconButton>
                    </TableCell>
                    <TableCell>{moment(data.date).format("YYYY-MM-DD, ddd")}{displaytext}</TableCell>
                    <TableCell><Tag color={color} style={{ fontWeight: "bold" }} >{data.type}</Tag></TableCell>

                    <TableCell>{data.workdurationperday == 0 ? "-" : convertSecondsToTime(data.workdurationperday)}</TableCell>

                    <TableCell>{data.extraperday == 0 ? "-" : convertSecondsToTime(data.extraperday)}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box margin={1}>
                                {/* <Typography variant="h6" gutterBottom component="div">
                                    Details
                                </Typography> */}
                                <TableMUI size="small" aria-label="purchases">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>In</TableCell>
                                            <TableCell>Out</TableCell>
                                            <TableCell>Work</TableCell>
                                            <TableCell>Extra</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            data.details ?
                                                data.details.map((detailItem, index) => (
                                                    detailItem.sections == 'full' ?

                                                        <TableRow key={index}>
                                                            <TableCell><a>{detailItem.type}</a></TableCell>
                                                            <TableCell><a>{"Full"}</a></TableCell>
                                                        </TableRow>
                                                        :
                                                        detailItem.sections == 'half' ?
                                                            <TableRow key={index}>
                                                                <TableCell><a>{detailItem.type}</a></TableCell>
                                                                <TableCell><a>{"Half"}</a></TableCell>
                                                            </TableRow>
                                                            :
                                                            detailItem.type == 'Free' ?
                                                                <TableRow key={index}>
                                                                    <TableCell><a>{"Free"}</a></TableCell>
                                                                    <TableCell>{""}</TableCell>
                                                                    <TableCell>{convertSecondsToTime(detailItem.workduration)}</TableCell>
                                                                    <TableCell>{convertSecondsToTime(detailItem.extra)}</TableCell>
                                                                </TableRow>
                                                                :
                                                                (['AL', 'MC', 'EL', 'UL', "HL", 'Trip'].includes(detailItem.type)) ?
                                                                    <TableRow key={index}>
                                                                        <TableCell><a>{detailItem.type}</a></TableCell>
                                                                        <TableCell><a>{"Full"}</a></TableCell>
                                                                    </TableRow>
                                                                    :
                                                                    <TableRow key={index}>
                                                                        <TableCell>{formatTimestampToTime(detailItem.punchin, detailItem.dts)} - {detailItem.branchin == '' ? 'Outside' : detailItem.branchin} </TableCell>
                                                                        <TableCell>{detailItem.punchout != '' ? `${formatTimestampToTime(detailItem.punchout, detailItem.dts)} - ${detailItem.branchout == '' ? "Outside" : detailItem.branchout}` : ''}</TableCell>
                                                                        <TableCell>{convertSecondsToTime(detailItem.workduration)}</TableCell>
                                                                        <TableCell>{convertSecondsToTime(detailItem.extra)}</TableCell>
                                                                    </TableRow>


                                                ))
                                                :
                                                ''
                                        }


                                    </TableBody>
                                </TableMUI>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </>
        );
    };


    // EXPANDABLE
    const expandedFlexibleDateRender = (record) => {
        //===== CALL DATASOURCE (DETAILS) =====
        if (shiftFilter == 'flexible') {
            // let color;
            // switch (data) {
            //     case "Att":
            //         color = "green";
            //         break;
            //     case "WFH":
            //         color = "blue";
            //         break;
            //     case "AL":
            //         color = "cyan";
            //         break;
            //     case "MC":
            //         color = "purple";
            //         break;
            //     case "EL":
            //         color = "orange";
            //         break;
            //     default:
            //         color = "";
            //         break;
            // }
            return (
                <>
                    <TableContainer component={Paper}>
                        <TableMUI size="small" aria-label="purchases">
                            <TableHead>
                                <TableRow>
                                    <TableCell />
                                    <TableCell>Date</TableCell>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Work</TableCell>
                                    <TableCell>Extra</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {record.newdetails.map((row, index) => (
                                    <Row1 key={index} data={row} />
                                ))}

                            </TableBody>
                        </TableMUI>
                    </TableContainer>

                </>
            )
        }
        else {
            return (
                <>
                    <div>Remark : {record.remark}</div>
                    <div style={{ color: record.isenoughduration == 1 ? "green" : record.isnotenoughduration == 1 ? "red" : "" }}>
                        Enough Duration (Min)  : {record.isenoughduration == 1 ? Number(Number(record.enoughduration) / 60).toFixed(1) : Number((Number(record.notenoughduration) * -1) / 60).toFixed(1)}
                    </div>
                    <div style={{ color: record.isenoughduration == 1 ? "green" : record.isnotenoughduration == 1 ? "red" : "" }}>
                        Enough Duration (Hrs)   : {record.isenoughduration == 1 ? Number(Number(record.enoughduration) / 60 / 60).toFixed(1) : (Number(Number(record.notenoughduration) * -1) / 60 / 60).toFixed(1)}
                    </div>
                    {/* IF HAS OT */}
                    {/* {(() => {
                            return getUserbyId({ userid: record.username })
                            .then(res => {
                                if(res.status == "ok"){
                                    return (
                                        <></>
                                    )
                                }
                                else{
                                    return (
                                        <></>
                                    )
                                }
                            })
                        })()} */}
                </>
            )
        }

    }
    const expandedMonthRender = (record) => {
        return (
            <Table
                columns={showDetailsTablecolumns}
                //dataSource={detailsTable[record.username]}
                dataSource={record.newdetails}
                expandable={{ expandedRowRender: expandedDateRender }}
            />
        )
    }

    const expandedFlexibleMonthRender = (record) => {
        return (
            <Table
                columns={showFlexibleDatecolumns}
                dataSource={record}
            //expandable={{ expandedRowRender: expandedDateRender }}
            />
        )
    }

    const onDateFilter = (date) => {
        setleavetypefilter(undefined);
        setDateFilter(date);
    }

    const onShiftFilter = (date) => {
        setleavetypefilter(undefined);
        setShiftFilter(date);
    }

    //20210906 ON GET DATASOURCE 
    const onGetDatasource = (data, searchuser, startDate, endDate, worktypeids, holidayslist) => {

        if (data != undefined) {
            if (data.length > 0) {
                setusertaken(data.length);
            }
        }

        let array = [];

        for (var i = 0; i < userLists.length; i++) {
            let userid = userLists[i]._id || "";
            let companyid = userLists[i].companyid || ""
            let totallate = 0;
            let totalearly = 0;
            let totallatemin = 0;
            let totalatt = 0;
            let totalmc = 0;
            let totalal = 0;
            let totalel = 0;
            let totalwfh = 0;
            let totalmiss = 0;
            let totalul = 0;
            let totalph = 0;
            let totalph1 = 0;
            let totalhl = 0;
            let totaltrip = 0;
            let reduceleavetime = 0;
            let newDetails = [];

            if (holidayslist) {
                holidayslist.forEach(value => {

                    if (value.allcompany == 1) {
                        if (moment(value.date).day() == 0 || moment(value.date).day() == 6) {
                            totalph1 += 1
                        }
                        else {
                            totalph += 1
                        }
                    }
                    else if (value.companylist.includes(companyid)) {
                        if (moment(value.date).day() == 0 || moment(value.date).day() == 6) {
                            totalph1 += 1
                        }
                        else {
                            totalph += 1
                        }
                    }

                })
            }


            const isUserShiftIncluded = worktypeids.includes(userLists[i].shift);
            if (isUserShiftIncluded) {
                let shiftworkhour = shiftlist.filter(x => x._id == userLists[i].shift)[0].durationperweek ? shiftlist.filter(x => x._id == userLists[i].shift)[0].durationperweek : 0
                let weekworkdayrange = shiftlist.filter(x => x._id == userLists[i].shift)[0].workingdays ? shiftlist.filter(x => x._id == userLists[i].shift)[0].workingdays : 0
                let userexist = data.filter(x => x.username == userid);


                if (userexist.length > 0) {
                    // Check if userShiftId is included in filterworktypeIds
                    let previousedate = ''

                    userexist.forEach(value => {
                        //==== FOR EARLY AND LATE =====
                        totalearly += value.isearly;
                        totallate += value.islate;
                        totallatemin += value.late;
                        let checkdate = value.date

                        if (shiftFilter == 'flexible') {
                            //==== FOR TYPE ======
                            let sectionvalue = 1
                            if (value.sections) {
                                if (value.sections == 'half') {
                                    sectionvalue = 0.5
                                }
                            }
                            switch (value.type) {
                                case "Att":
                                    if (checkdate != previousedate) {
                                        totalatt += sectionvalue;
                                        previousedate = checkdate

                                    }
                                    break;
                                case "WFH":
                                    totalwfh += sectionvalue;
                                    break;
                                case "AL":
                                    totalal += sectionvalue;
                                    break;
                                case "MC":
                                    totalmc += sectionvalue;
                                    break;
                                case "EL":
                                    totalel += sectionvalue;
                                    break;
                                case "MISSED":
                                    totalmiss += sectionvalue;
                                    break;
                                case "UL":
                                    totalul += sectionvalue;
                                    break;
                                case "PH":
                                    totalph += sectionvalue;
                                    break;
                                case "HL":
                                    totalhl += sectionvalue;
                                    break;
                                case "Trip":
                                    totaltrip += sectionvalue;
                                    break;
                            }
                        }
                        else {
                            let sectionvalue = 1
                            if (value.sections) {
                                if (value.sections == 'half') {
                                    sectionvalue = 0.5
                                }
                            }
                            //==== FOR TYPE ======
                            switch (value.type) {
                                case "Att":
                                    totalatt += sectionvalue;
                                    break;
                                case "WFH":
                                    totalwfh += sectionvalue;
                                    break;
                                case "AL":
                                    totalal += sectionvalue;
                                    break;
                                case "MC":
                                    totalmc += sectionvalue;
                                    break;
                                case "EL":
                                    totalel += sectionvalue;
                                    break;
                                case "MISSED":
                                    totalmiss += sectionvalue;
                                    break;
                                case "UL":
                                    totalul += sectionvalue;
                                    break;
                                case "PH":
                                    totalph += sectionvalue;
                                    break;
                                case "HL":
                                    totalhl += sectionvalue;
                                    break;
                                case "Trip":
                                    totaltrip += sectionvalue;
                                    break;
                            }
                        }

                    });


                    const sumWorkDuration = userexist.length > 0
                        ? userexist.reduce((acc, item) => {
                            acc += item.workduration || 0;
                            return acc;
                        }, 0)
                        : 0;

                    const sumExtra = userexist.length > 0
                        ? userexist.reduce((acc, item) => {
                            acc += item.extra || 0;
                            return acc;
                        }, 0)
                        : 0;

                    const hasEmptyPunchout = userexist.some(item => item.punchout === "" || item.punchout === undefined);

                    var missingpunchout = 0
                    if (hasEmptyPunchout) {
                        missingpunchout = 1
                    }

                    // Initialize an object to store the summed workduration for each unique date
                    const summedWorkDurationByDate = {};
                    let prevDate = null;
                    let tempworkduration = 0
                    // Iterate through the array and sum up workduration for specific types

                    let workdurationperday = userexist[0]["workdurationperday"] = sumWorkDuration;
                    let extraperday = userexist[0]["extraperday"] = sumExtra;

                    let details = userexist
                    let type = userexist[0]["type"] || "";
                    let islate = userexist[0]["islate"] || 0;
                    let isearly = userexist[0]["isearly"] || 0;
                    let punchin = userexist[0]["punchin"] || "";
                    let punchout = userexist[0]["punchout"] || "";
                    let branchin = userexist[0]["branchin"] || "";
                    let branchout = userexist[0]["branchout"] || "";
                    let bipin = userexist[0]["bipin"] || "";
                    let bipout = userexist[0]["bipout"] || "";
                    let remark = userexist[0]["remark"] || "";
                    let isenoughduration = userexist[0]["isenoughduration"] || 0;
                    let isnotenoughduration = userexist[0]["isnotenoughduration"] || 0;
                    let enoughduration = userexist[0]["enoughduration"] || "";
                    let notenoughduration = userexist[0]["notenoughduration"] || "";

                    if (dateFilter != 'date') {
                        let startofMth = moment(startDate, "YYYY/MM/DD");
                        let endOfMth = moment(endDate, "YYYY/MM/DD");


                        for (var m = startofMth; m <= endOfMth; m.add(1, 'days')) {


                            var val = {
                                key: m.format("YYYY-MM-DD"),
                                date: m.format("YYYY-MM-DD"),
                                type: "",
                                punchin: "",
                                punchout: "",
                                branchin: "",
                                branchout: "",
                                isearly: 0,
                                islate: 0,
                                remark: "",
                                isenoughduration: 0,
                                isnotenoughduration: 0,
                                enoughduration: "",
                                notenoughduration: "",
                                workdurationperday: 0,
                                extraperday: 0,
                                missingpunchout: 0,
                                details: '',
                                sections: ''
                            }

                            //====== IF GOT USER EXIST CHECK BASED ON DTS ====
                            var usrFilter = userexist.filter(x => x.dts == m.unix());
                            if (usrFilter.length > 0) {

                                const sumWorkDuration = usrFilter.length > 0
                                    ? usrFilter.reduce((acc, item) => {
                                        acc += item.workduration || 0;
                                        return acc;
                                    }, 0)
                                    : 0;

                                const sumExtra = usrFilter.length > 0
                                    ? usrFilter.reduce((acc, item) => {
                                        acc += item.extra || 0;
                                        return acc;
                                    }, 0)
                                    : 0;

                                const hasEmptyPunchout = usrFilter.some(item => item.punchout === "" || item.punchout === undefined);

                                var missingpunchout = 0
                                if (hasEmptyPunchout) {
                                    missingpunchout = 1
                                }

                                val.type = usrFilter[0].type;
                                val.punchin = usrFilter[0].punchin;
                                val.punchout = usrFilter[0].punchout;
                                val.branchin = usrFilter[0].branchin;
                                val.branchout = usrFilter[0].branchout;
                                val.isearly = usrFilter[0].isearly;
                                val.islate = usrFilter[0].islate;
                                val.remark = usrFilter[0].remark;
                                val.isenoughduration = usrFilter[0].isenoughduration;
                                val.isnotenoughduration = usrFilter[0].isnotenoughduration;
                                val.enoughduration = usrFilter[0].enoughduration;
                                val.notenoughduration = usrFilter[0].notenoughduration;
                                val.workdurationperday = sumWorkDuration;
                                val.extraperday = sumExtra;
                                val.missingpunchout = missingpunchout;
                                val.details = usrFilter;
                                val.sections = usrFilter[0].sections ? usrFilter[0].sections : ''
                            }

                            //===== CHECK USER EXISTS =======
                            newDetails.push(val);
                        }
                    }

                    array.push({
                        key: userLists[i].userid,
                        type: type,
                        details: details,
                        username: userLists[i].userid,
                        islate: islate,
                        isearly: isearly,
                        punchin: punchin,
                        punchout: punchout,
                        branchin: branchin == "" || branchin == undefined ? bipin : branchin,
                        branchout: branchout == "" || branchout == undefined ? bipout : branchout,
                        remark: remark,
                        isenoughduration: isenoughduration,
                        isnotenoughduration: isnotenoughduration,
                        enoughduration: enoughduration,
                        notenoughduration: notenoughduration,
                        workdurationperday: workdurationperday,
                        extraperday: extraperday,
                        missingpunchout: missingpunchout,
                        totalearly: totalearly,
                        totallate: totallate,
                        totallatenessbyhr: Number(Number(totallatemin) / 60 / 60).toFixed(1),
                        totallatenessbymin: Number(Number(totallatemin) / 60).toFixed(1),
                        totalatt: totalatt,
                        totalwfh: totalwfh,
                        totalal: totalal,
                        totalel: totalel,
                        totalmc: totalmc,
                        totalmiss: totalmiss,
                        totalul: totalul,
                        totalph: totalph,
                        totalph1: totalph1,
                        totalhl: totalhl,
                        totaltrip: totaltrip,
                        newdetails: newDetails,
                        shiftworkhour: shiftworkhour,
                        weekworkdayrange: weekworkdayrange,
                        reduceleavetime: reduceleavetime,


                    });
                }
                else {
                    array.push({
                        key: userLists[i].userid,
                        type: "",
                        username: userLists[i].userid,
                        islate: 0,
                        isearly: 0,
                        punchin: "",
                        punchout: "",
                        branchin: "",
                        branchout: "",
                        remark: "",
                        isenoughduration: 0,
                        isnotenoughduration: 0,
                        enoughduration: "",
                        notenoughduration: "",
                        workdurationperday: 0,
                        extraperday: 0,
                        missingpunchout: 0,
                        totalearly: totalearly,
                        totallate: totallate,
                        totallatenessbyhr: Number(Number(totallatemin) / 60 / 60).toFixed(1),
                        totallatenessbymin: Number(Number(totallatemin) / 60).toFixed(1),
                        totalatt: totalatt,
                        totalwfh: totalwfh,
                        totalal: totalal,
                        totalel: totalel,
                        totalmc: totalmc,
                        totalmiss: totalmiss,
                        totalul: totalul,
                        totalph: totalph,
                        totalph1: totalph1,
                        totalhl: totalhl,
                        totaltrip: totaltrip,
                        newdetails: newDetails,
                        shiftworkhour: shiftworkhour,
                        weekworkdayrange: weekworkdayrange,
                        reduceleavetime: reduceleavetime,
                    });
                }



            }

        }


        console.log("final array >>>", array)
        if (searchuser == "") {

            return array;
        }
        else {

            array = array.filter(x => x.username == searchuser);

            return array;
        }





        // else if (dateFilter == "month") {
        //     let array = onGetMonthDetails(data, startDate, endDate, searchuser,worktypeids);
        //     return array;
        // }
        // else if (dateFilter == "monthrange") {
        //     let array = onGetMonthDetails(data, startDate, endDate, searchuser,worktypeids);
        //     return array;
        // }
        // else if (dateFilter == "weekrange") {
        //     let array = onGetMonthDetails(data, startDate, endDate, searchuser,worktypeids);
        //     return array;
        // }
        // else if (dateFilter == "week") {
        //     let array = onGetMonthDetails(data, startDate, endDate, searchuser,worktypeids);
        //     return array;
        // }
    }

    // 20210927 ON GET MONTH DATASOURCE 
    const onGetMonthDetails = (data, startDate, endDate, user, worktypeids) => {
        let array = [];
        let details = {};
        //20210907 ON GET MONTH DATASOURCE
        for (var i = 0; i < userLists.length; i++) {
            let totallate = 0;
            let totalearly = 0;
            let totallatemin = 0;
            let totalatt = 0;
            let totalmc = 0;
            let totalal = 0;
            let totalel = 0;
            let totalwfh = 0;
            let totalmiss = 0;
            let totalul = 0;
            let totalph = 0;
            let totalhl = 0;
            let userid = userLists[i]._id;

            let userexist = data.filter(x => x.username == userid);
            const isUserShiftIncluded = worktypeids.includes(userLists[i].shift);
            if (isUserShiftIncluded) {

            }
            if (userexist.length > 0) {
                userexist.forEach(value => {
                    //==== FOR EARLY AND LATE =====
                    totalearly += value.isearly;
                    totallate += value.islate;
                    totallatemin += value.late;

                    //==== FOR TYPE ======
                    switch (value.type) {
                        case "Att":
                            totalatt += 1;
                            break;
                        case "WFH":
                            totalwfh += 1;
                            break;
                        case "AL":
                            totalal += 1;
                            break;
                        case "MC":
                            totalmc += 1;
                            break;
                        case "EL":
                            totalel += 1;
                            break;
                        case "MISSED":
                            totalmiss += 1;
                            break;
                        case "UL":
                            totalul += 1;
                            break;
                        case "PH":
                            totalph += 1;
                            break;
                        case "HL":
                            totalhl += 1;
                            break;
                    }
                });
            }

            array.push({
                key: userLists[i].userid,
                username: userLists[i].userid,
                totalearly: totalearly,
                totallate: totallate,
                totallatenessbyhr: Number(Number(totallatemin) / 60 / 60).toFixed(1),
                totallatenessbymin: Number(Number(totallatemin) / 60).toFixed(1),
                totalatt: totalatt,
                totalwfh: totalwfh,
                totalal: totalal,
                totalel: totalel,
                totalmc: totalmc,
                totalmiss: totalmiss,
                totalul: totalul,
                totalph: totalph,
                totalhl: totalhl
            })

            //===== SET DETAILS DATASOURCE =====
            if (details[userid] == undefined) { details[userid] = [] }

            // console.log('moment date >>> ', moment(allDate, "YYYY/MM"))
            // console.log('end days >>> ', moment(allDate, "YYYY/MM").daysInMonth());
            // console.log('DAYS >>> ', moment(allDate, "YYYY/MM").add(moment(allDate, "YYYY/MM").daysInMonth(), 'days'));

            // let startofMth = moment(startDate, "YYYY/MM/DD");
            // let endOfMth = moment(endDate, "YYYY/MM/DD").add(moment(endDate, "YYYY/MM/DD").daysInMonth(), 'days');

            let startofMth = moment(startDate, "YYYY/MM/DD");
            let endOfMth = moment(endDate, "YYYY/MM/DD");
            let newDetails = [];
            console.log("startofMth >>>", startofMth)

            console.log("endOfMth >>>", endOfMth)
            for (var m = startofMth; m.isBefore(endOfMth); m.add(1, 'days')) {
                console.log("m.format(YYYY-MM-DD) >>>", m.format("YYYY-MM-DD"))
                var val = {
                    key: m.format("YYYY-MM-DD"),
                    date: m.format("YYYY-MM-DD"),
                    type: "",
                    punchin: "",
                    punchout: "",
                    branchin: "",
                    branchout: "",
                    isearly: 0,
                    islate: 0,
                    remark: "",
                    isenoughduration: 0,
                    isnotenoughduration: 0,
                    enoughduration: "",
                    notenoughduration: ""
                }

                //====== IF GOT USER EXIST CHECK BASED ON DTS ====
                var usrFilter = userexist.filter(x => x.dts == m.unix());
                if (usrFilter.length > 0) {
                    val.type = usrFilter[0].type;
                    val.punchin = usrFilter[0].punchin;
                    val.punchout = usrFilter[0].punchout;
                    val.branchin = usrFilter[0].branchin;
                    val.branchout = usrFilter[0].branchout;
                    val.isearly = usrFilter[0].isearly;
                    val.islate = usrFilter[0].islate;
                    val.remark = usrFilter[0].remark;
                    val.isenoughduration = usrFilter[0].isenoughduration;
                    val.isnotenoughduration = usrFilter[0].isnotenoughduration;
                    val.enoughduration = usrFilter[0].enoughduration;
                    val.notenoughduration = usrFilter[0].notenoughduration;
                }

                //===== CHECK USER EXISTS =======
                newDetails.push(val);
            }


            details[userLists[i].userid] = newDetails;
        }

        console.log("detials >>>", details)
        setDetailsTable(details);

        //==== IF GOT SEARCH USER ====
        if (user == "") {
            return array;
        }
        else {
            array = array.filter(x => x.username == user);
            return array;
        }
    }

    // 20210906 Summary
    const onSummary = (pageData) => {
        let totallate = 0;
        let totalearly = 0;

        pageData.forEach(({ islate, isearly }) => {
            totallate += islate;
            totalearly += isearly;
        });

        // ====== DATE SUMMARY ======
        if (dateFilter == "date") {
            return (
                <>
                    <Table.Summary.Row>
                        <Table.Summary.Cell></Table.Summary.Cell>
                        <Table.Summary.Cell>
                            Total User : <Text>{totaluser}</Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                            User attendance taken : <Text>{usertaken}</Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                            User without take : <Text>{userleft}</Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                            Early : <Text type="success">{totalearly}</Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                            Late : <Text type="danger">{totallate}</Text>
                        </Table.Summary.Cell>
                    </Table.Summary.Row>
                </>
            )
        }
        else {
            return (
                <>
                </>
            )
        }

    }

    //====== ON USER SEARCH ======
    const onSearchUser = (user) => {


        let tempuserid = user

        let tempshift = shiftFilter
        if (user.length > 0) {
            tempuserid = userLists.filter(x => x.userid == user)[0]._id;

        }
        setSearchUser(user);
        if (dateFilter == "monthrange") {
            onMonthRefresh({ searchuser: tempuserid, shifttype: tempshift }).then(val => {
                setDatasource(val.data);
            });
        }
        else {
            onRefresh({ searchuser: tempuserid, shifttype: tempshift }).then(val => {

                if (leavetypefilter == undefined) {
                    setDatasource(val.data);
                }
                else {
                    let newds = val.data.filter(x => x.type == leavetypefilter);
                    setDatasource(newds);
                }
            });
        }
    }

    //======== FORM  ============
    const onAttendanceMgmtForm = () => {
        return (
            <>
                <Row justify="start">
                    <Divider>{prop.title ?? "."}</Divider>
                </Row>
                {/* HEADER */}
                {/* BODY */}
                <Row>
                    <Col span={24}>
                        <div style={{ float: "right" }}>
                            <Space size={2}>
                                <Tooltip placement="bottom" title={"Export To Excel"}>
                                    <Button onClick={onExportToExcel}><VerticalAlignBottomOutlined /></Button>
                                </Tooltip>
                                <Button onClick={onReload}>{btndisable ? <Spin /> : <ReloadOutlined />}</Button>
                            </Space>
                        </div>

                    </Col>
                </Row>
                {onFilterForm()}
                <Divider />
                <Table {...tableProps} expandable={{ expandedRowRender: dateFilter == "date" ? expandedDateRender : shiftFilter == "flexible" ? expandedFlexibleDateRender : expandedMonthRender }} />
            </>
        )
    }

    const onFilterForm = () => {
        return (
            <>
                <Row>
                    <Col span={4}>
                        <div style={{ display: "inline", marginRight: "10px" }}>
                            Filter By:
                        </div>
                        {
                            shiftFilter == 'flexible' ?
                                <Select style={{ width: "100px" }} value={dateFilter} onChange={onDateFilter}>
                                    <Option value={"date"}>Date</Option>
                                    <Option value={"week"}>Week</Option>
                                    {/* <Option value={"month"}>Month</Option>
                            <Option value={"weekrange"}>Week Range</Option>
                            <Option value={"monthrange"}>Month Range</Option> */}
                                </Select>
                                :
                                <Select style={{ width: "100px" }} value={dateFilter} onChange={onDateFilter}>
                                    <Option value={"date"}>Date</Option>
                                    <Option value={"week"}>Week</Option>
                                    <Option value={"month"}>Month</Option>
                                    {/* <Option value={"weekrange"}>Week Range</Option>
                            <Option value={"monthrange"}>Month Range</Option> */}
                                </Select>
                        }

                    </Col>
                    <Col span={4}>
                        <Select style={{ width: "100px" }} value={shiftFilter} onChange={onShiftFilter}>
                            <Option value={"flexible"}>Flexible</Option>
                            <Option value={"fixed"}>Fixed</Option>

                        </Select>
                    </Col>
                </Row>
                <Row gutter={[8, 8]}>
                    {/* SELECT DATE */}
                    <Col span={6}>
                        {dateFilter == "monthrange" ?
                            <RangePicker {...monthrangeprops}></RangePicker>
                            :
                            dateFilter == "week" ?
                                <DatePicker {...weekprops}></DatePicker>
                                :
                                dateFilter == "weekrange" ?
                                    <RangePicker {...weekrangeprops}></RangePicker>
                                    :
                                    dateFilter == "month" ?
                                        <DatePicker {...monthprops}></DatePicker>
                                        :
                                        <DatePicker {...dateprops}></DatePicker>
                        }
                    </Col>
                    {dateFilter == "date" ?
                        <Col span={6}>
                            <Select {...leaveSelectprops} >
                                {leavetypes.map(leave => {
                                    return (
                                        <Option value={leave}>{leave}</Option>
                                    )
                                })}
                            </Select>
                        </Col> : null
                    }
                    <Col span={6}>
                        <Select style={{ width: "100%" }} placeholder={"Search User"} onChange={onSearchUser} allowClear showSearch>
                            {
                                userLists.map(function (data) {
                                    return (
                                        <Option value={data.userid}>{data.userid}</Option>
                                    )
                                })}
                        </Select>
                    </Col>
                    <Col span={6}>
                        <Select style={{ width: "100%" }} disabled>
                            <Option value={"oldest"}>Oldest</Option>
                            <Option value={"newest"}>Newest</Option>
                        </Select>
                    </Col>
                </Row>
            </>
        )
    }

    //==== TABLE ======
    // Fixed DATE TABLE COLUMNS
    const showFixedDatecolumns = [{
        title: "Name",
        dataIndex: "username",
        render: (data, fulldata) => {

            return (
                <div>
                    <p style={{ fontWeight: "bold" }} >{data}</p>
                </div>
            )

        }
    },
    {
        title: "Type",
        dataIndex: "type",
        sorter: (a, b) => a.type - b.type,
        ellipsis: true,
        align: 'right',
        render: data => {
            let color;
            switch (data) {
                case "Att":
                    color = "green";
                    break;
                case "WFH":
                    color = "blue";
                    break;
                case "AL":
                    color = "cyan";
                    break;
                case "MC":
                    color = "purple";
                    break;
                case "EL":
                    color = "orange";
                    break;
                case "Free":
                    color = "grey";
                    break;
                case "Trip":
                    color = "volcano";
                    break;
                default:
                    color = "";
                    break;
            }

            return (
                <div>
                    <Tag color={color} style={{ fontWeight: "bold" }} >{data}</Tag>
                </div>
            )
        }
    },
    {
        title: "Clock In",
        dataIndex: "punchin",
        align: 'right',
        render: (data) => {
            if (data == "") {
                return (<div>-</div>)
            }
            return (
                <div>
                    {moment.unix(data).format("h:mm a")}
                </div>
            )
        }
    },
    {
        title: "Clock Out",
        dataIndex: "punchout",
        align: 'right',
        render: (data) => {
            if (data == "") {
                return (<div>-</div>)
            }
            return (
                <div>
                    {moment.unix(data).format("h:mm a")}
                </div>
            )
        }
    },
    {
        title: "Branch In",
        dataIndex: "branchin",
        align: 'right',
        render: (data) => {
            if (data == "") {
                return (<div>-</div>)
            }

            return (
                <div>{data}</div>
            )
        }
    },
    {
        title: "Branch Out",
        dataIndex: "branchout",
        align: 'right',
        render: (data) => {
            if (data == "") {
                return (<div>-</div>)
            }

            return (
                <div>{data}</div>
            )
        }
    }];
    // Flexibleed DATE TABLE COLUMNS
    const showFlexibleDatecolumns = [{
        title: "Name",
        dataIndex: "username",
        render: (data, fulldata) => {

            var displaytext = ''
            if (fulldata.details) {
                var countmissing = 0
                if (fulldata.missingpunchout == 1) {
                    countmissing = 1
                }

                displaytext = `${data}(${fulldata.details.length - countmissing})`
            }
            else {
                displaytext = data
            }
            return (
                <div>
                    <p style={{ fontWeight: "bold", color: fulldata.missingpunchout == 1 ? "red" : "" }} >{`${displaytext}`}</p>
                </div>
            )

        }
    },
    {
        title: "Type",
        dataIndex: "type",
        sorter: (a, b) => a.type - b.type,
        ellipsis: true,
        align: 'right',
        render: data => {
            let color;
            switch (data) {
                case "Att":
                    color = "green";
                    break;
                case "WFH":
                    color = "blue";
                    break;
                case "AL":
                    color = "cyan";
                    break;
                case "MC":
                    color = "purple";
                    break;
                case "EL":
                    color = "orange";
                    break;
                case "Free":
                    color = "grey";
                    break;
                case "Trip":
                    color = "volcano";
                    break;
                default:
                    color = "";
                    break;
            }

            return (
                <div>
                    <Tag color={color} style={{ fontWeight: "bold" }} >{data}</Tag>
                </div>
            )
        }
    },
    {
        title: "Work ",
        dataIndex: "workdurationperday",
        align: 'right',
        render: (data) => {
            if (data == "") {
                return (<div>-</div>)
            }
            return (
                <div>
                    {convertSecondsToTime(data)}
                </div>
            )
        }
    },
    {
        title: "Extra",
        dataIndex: "extraperday",
        align: 'right',
        render: (data) => {
            if (data == "") {
                return (<div>-</div>)
            }
            return (
                <div>
                    {convertSecondsToTime(data)}
                </div>
            )
        }
    },
    {
        title: "",
        dataIndex: "extraperday",
        align: 'right',
        render: (data) => {
            if (data == "") {
                return (<div></div>)
            }
            return (
                <div>

                </div>
            )
        }
    },
    ];

    // MONTH TABLE COLUMNS
    const showMonthcolumns = [{
        title: "Name",
        dataIndex: "username"
    },
    // {
    //     title       : "Total Early (Days)",
    //     dataIndex   : "totalearly",
    //     align       : 'right',
    //     render      : (data) => {
    //         return (
    //             <div>{data}</div>
    //         )
    //     }
    // },
    // {
    //     title       : "Lateness (Hr)",
    //     dataIndex   : "totallatenessbyhr",
    //     align       : 'right',
    //     render      : (data) => {
    //         return (
    //             <div>{data}</div>
    //         )
    //     }
    // },
    {
        title: "Total Attendance (Days)",
        dataIndex: "totalatt",
        align: 'right',
        render: (data) => {
            return (
                <div>{data}</div>
            )
        }
    },
    {
        title: "Lateness (Min)",
        dataIndex: "totallatenessbymin",
        align: 'right',
        render: (data) => {
            return (
                <div>{data}</div>
            )
        }
    },
    {
        title: "Lateness (Days)",
        dataIndex: "totallate",
        align: 'right',
        render: (data) => {
            return (
                <div>{data}</div>
            )
        }
    },
    {
        title: "Total WFH (Days)",
        dataIndex: "totalwfh",
        align: 'right',
        render: (data) => {
            return (
                <div>{data}</div>
            )
        }
    },
    {
        title: "Total AL (Days)",
        dataIndex: "totalal",
        align: 'right',
        render: (data) => {
            return (
                <div>{data}</div>
            )
        }
    },
    {
        title: "Total EL (Days)",
        dataIndex: "totalel",
        align: 'right',
        render: (data) => {
            return (
                <div>{data}</div>
            )
        }
    },
    {
        title: "Total MC (Days)",
        dataIndex: "totalmc",
        align: 'right',
        render: (data) => {
            return (
                <div>{data}</div>
            )
        }
    },
    {
        title: "Total Miss (Days)",
        dataIndex: "totalmiss",
        align: 'right',
        render: (data) => {
            return (
                <div>{data}</div>
            )
        }
    },
    {
        title: "Total UL (Days)",
        dataIndex: "totalul",
        align: 'right',
        render: (data) => {
            return (
                <div>{data}</div>
            )
        }
    },
    {
        title: "Total PH (Days)",
        dataIndex: "totalph",
        align: 'right',
        render: (data) => {
            return (
                <div>{data}</div>
            )
        }
    },
    {
        title: "Total HL (Days)",
        dataIndex: "totalhl",
        align: 'right',
        render: (data) => {
            return (
                <div>{data}</div>
            )
        }
    }];

    // MONTH TABLE COLUMNS
    const showFlexibleMonthcolumns = [{
        title: "Name",
        dataIndex: "username"
    },
    // {
    //     title       : "Total Early (Days)",
    //     dataIndex   : "totalearly",
    //     align       : 'right',
    //     render      : (data) => {
    //         return (
    //             <div>{data}</div>
    //         )
    //     }
    // },
    // {
    //     title       : "Lateness (Hr)",
    //     dataIndex   : "totallatenessbyhr",
    //     align       : 'right',
    //     render      : (data) => {
    //         return (
    //             <div>{data}</div>
    //         )
    //     }
    // },
    {
        title: "Shift Hours",
        dataIndex: "shiftworkhour",
        align: 'right',
        render: (data, fullrecord) => {
            return (
                <div>{convertSecondsToTime(data * 3600)}</div>
            )
        }
    },
    {
        title: "Leave / Holidays",
        dataIndex: "totalmiss",
        align: 'right',
        render: (data, fullrecord) => {
            var countdays = fullrecord.totalel + fullrecord.totalmc + fullrecord.totalul + fullrecord.totalal + fullrecord.totalph + fullrecord.totaltrip
            var workhoursperday = fullrecord.shiftworkhour / fullrecord.weekworkdayrange.length
            var finalresult = ((workhoursperday * countdays) * 3600) - fullrecord.reduceleavetime
            return (
                <div>{convertSecondsToTime(finalresult)}</div>
            )
        }
    },
    {
        title: "Total Working",
        dataIndex: "workdurationperday",
        align: 'right',
        render: (data) => {
            return (
                <div>{convertSecondsToTime(data)}</div>
            )
        }
    },
    {
        title: "Week Balance",
        dataIndex: "shiftworkhour",
        align: 'right',
        render: (data, fullrecord) => {
            var balancehours = (fullrecord.shiftworkhour * 3600) - fullrecord.workdurationperday
            var colortoshow = ''
            var holidayscountdays = fullrecord.totalel + fullrecord.totalmc + fullrecord.totalul + fullrecord.totalal + fullrecord.totalph + fullrecord.totaltrip
            var workhoursperday = fullrecord.shiftworkhour / fullrecord.weekworkdayrange.length


            balancehours = balancehours - (workhoursperday * holidayscountdays * 3600)
            if (balancehours <= 0) {
                colortoshow = 'green'
                balancehours = balancehours * -1
            }
            return (
                <div><strong style={{ color: colortoshow }}>{balancehours <= 0 ? `+${convertSecondsToTime(balancehours)}` : convertSecondsToTime(balancehours)}</strong></div>
            )
        }
    },
    {
        title: "Total Extra",
        dataIndex: "extraperday",
        align: 'right',
        render: (data) => {
            return (
                <div>{convertSecondsToTime(data)}</div>
            )
        }
    },
    {
        title: "Total WFH (Days)",
        dataIndex: "totalwfh",
        align: 'right',
        render: (data) => {
            return (
                <div>{data == 0 ? " - " : data}</div>
            )
        }
    },
    {
        title: "Total AL (Days)",
        dataIndex: "totalal",
        align: 'right',
        render: (data) => {
            return (
                <div>{data == 0 ? " - " : data}</div>
            )
        }
    },
    {
        title: "Total EL (Days)",
        dataIndex: "totalel",
        align: 'right',
        render: (data) => {
            return (
                <div>{data == 0 ? " - " : data}</div>
            )
        }
    },
    {
        title: "Total MC (Days)",
        dataIndex: "totalmc",
        align: 'right',
        render: (data) => {
            return (
                <div>{data == 0 ? " - " : data}</div>
            )
        }
    },
    {
        title: "Total UL (Days)",
        dataIndex: "totalul",
        align: 'right',
        render: (data) => {
            return (
                <div>{data == 0 ? " - " : data}</div>
            )
        }
    },
    {
        title: "Total Trip (Days)",
        dataIndex: "totaltrip",
        align: 'right',
        render: (data) => {
            return (
                <div>{data == 0 ? " - " : data}</div>
            )
        }
    },
    {
        title: "Total HL (Days)",
        dataIndex: "totalhl",
        align: 'right',
        render: (data) => {
            return (
                <div>{data == 0 ? " - " : data}</div>
            )
        }
    },
    {
        title: "Total PH (WeekDays)",
        dataIndex: "totalph",
        align: 'right',
        render: (data) => {

            return (

                <div>{data == 0 ? " - " : data}</div>
            )
        }
    },
    {
        title: "Total PH (WeekEnd)",
        dataIndex: "totalph1",
        align: 'right',
        render: (data) => {
            return (
                <div>{data == 0 ? " - " : data}</div>
            )
        }
    }];

    // MONTH DETAILS TABLE COLUMNS
    const showDetailsTablecolumns = [{
        title: "Date",
        dataIndex: "date",
        align: 'right',
        render: data => {
            return (
                <div>{moment(data).format("YYYY-MM-DD")}</div>
            )
        }
    }
        , {
        title: "Type",
        dataIndex: "type",
        sorter: (a, b) => a.type - b.type,
        ellipsis: true,
        align: 'right',
        render: data => {
            let color;
            switch (data) {
                case "Att":
                    color = "green";
                    break;
                case "WFH":
                    color = "blue";
                    break;
                case "AL":
                    color = "cyan";
                    break;
                case "MC":
                    color = "purple";
                    break;
                case "EL":
                    color = "orange";
                    break;
                default:
                    color = "";
                    break;
            }

            return (
                <div>
                    <Tag color={color} style={{ fontWeight: "bold" }} >{data}</Tag>
                </div>
            )
        }
    },
    {
        title: "Clock In",
        dataIndex: "punchin",
        align: 'right',
        render: (data, item) => {
            if (data == "") {
                return (<div>-</div>)
            }
            return (
                <div style={{ color: item.isearly == 1 ? "green" : "red" }}>
                    {moment.unix(data).format("h:mm a")}
                </div>
            )
        }
    },
    {
        title: "Clock Out",
        dataIndex: "punchout",
        align: 'right',
        render: (data) => {
            if (data == "") {
                return (<div>-</div>)
            }
            return (
                <div>
                    {moment.unix(data).format("h:mm a")}
                </div>
            )
        }
    },
    {
        title: "Branch In",
        dataIndex: "branchin",
        align: 'right',
        render: (data) => {
            if (data == "") {
                return (<div>-</div>)
            }

            return (
                <div>{data}</div>
            )
        }
    },
    {
        title: "Branch Out",
        dataIndex: "branchout",
        align: 'right',
        render: (data) => {
            if (data == "") {
                return (<div>-</div>)
            }

            return (
                <div>{data}</div>
            )
        }
    }]

    //======== PROPS ========
    const dateprops = {
        style: { width: "100%" },
        onChange: (date) => {
            setDate(date);
        },
        value: date,
        picker: "date"
    }

    const weekprops = {
        style: { width: "100%" },
        onChange: (date) => {
            setDatesRange(date);
        },
        picker: "week"
    }
    const monthprops = {
        style: { width: "100%" },
        onChange: (date) => {
            setDatesRange(date);
        },
        picker: "month"
    }

    const monthrangeprops = {
        style: { width: "100%" },
        onChange: (dates, dateStrings) => {
            setDatesRange(dates);
        },
        picker: "month"
    }

    const weekrangeprops = {
        style: { width: "100%" },
        onChange: (dates, dateStrings) => {
            setDatesRange(dates);
        },
        picker: "week"
    }

    const leaveSelectprops = {
        style: { width: "100%" },
        allowClear: true,
        value: leavetypefilter,
        placeholder: "Leave Type",
        onChange: setleavetypefilter
    }

    const tableProps = {
        dataSource: datasource,
        columns: dateFilter == "date"
            ?
            shiftFilter == "flexible"
                ?
                showFlexibleDatecolumns
                :
                showFixedDatecolumns
            :
            shiftFilter == "flexible"
                ?
                showFlexibleMonthcolumns
                :
                showMonthcolumns,
        pagination: false,
        sorter: true,
        scroll: { y: "100vw" },
        summary: onSummary
    }


    return (
        <>
            {(() => {
                if (isMaintenance) {
                    return (<T_Error />)
                }
                else {
                    return (
                        <>
                            {onAttendanceMgmtForm()}
                        </>
                    )
                }
            })()}
        </>
    )
}